import { useCallback } from 'react';
import { openUrlInNewTab } from '~/_shared/utils/link/link';
import { checkIsSalesforceMap } from '~/store/mapInfo/mapInfo.helpers';
import { useMapInfoDataSelector } from '~/store/mapInfo/mapInfo.selectors';
import { usePrimarySpreadsheetRealSpreadsheets } from '~/store/selectors/usePrimarySpreadsheetRealSpreadsheets';

export const useCreateRowExternal = () => {
  const mapInfo = useMapInfoDataSelector();
  const primaryRealSpreadsheets = usePrimarySpreadsheetRealSpreadsheets();

  const isSalesforceMap = checkIsSalesforceMap(mapInfo);

  const salesforceCreateRowExternal = useCallback(() => {
    const addNewDataRowLink = isSalesforceMap && primaryRealSpreadsheets?.[0]?.addRowLink
      ? primaryRealSpreadsheets[0].addRowLink
      : null;

    if (addNewDataRowLink) {
      openUrlInNewTab(addNewDataRowLink);
    }
  }, [isSalesforceMap, primaryRealSpreadsheets]);

  return {
    ...(isSalesforceMap ? { create: salesforceCreateRowExternal, isSalesforce: true } : {}),
  };
};
